import { useSearchParams } from "react-router-dom";
import "../style/components/footer.css";

export function Footer() {
  const [params, setParams] = useSearchParams();

  const openPrivacyPolicy = async () => {
    try {
      const response = await fetch("/privacy-policy.html");
      if (!response.ok) throw new Error("Failed to load privacy policy.");
      const html = await response.text();

      const popup = document.createElement("div");
      popup.className = "privacy-modal";

      const content = document.createElement("div");
      content.className = "privacy-content";
      content.innerHTML = html;

      const closeButton = document.createElement("button");
      closeButton.innerText = "Zamknij";
      closeButton.className = "privacy-close-button";
      closeButton.onclick = () => document.body.removeChild(popup);

      popup.appendChild(closeButton);
      popup.appendChild(content);
      document.body.appendChild(popup);
    } catch (error) {
      console.error("Błąd ładowania polityki prywatności:", error);
      alert("Nie udało się załadować polityki prywatności.");
    }
  };

  return (
    <footer id="page-footer">
      <div className="container">
        <section>
          <a href="https://radiopromil.online/station/radio-promil" type="svg" aria-label="Link to radiopromil.online">
            <img src={`${process.env.PUBLIC_URL}/promil_logo_wariant_kolor.png`} alt="Radio Promil" className="footer-logo" />
          </a>
        </section>
        <section>
          <a href="https://apps.apple.com/app/radio-promil/id1603061727" type="link" target="_blank" rel="noreferrer">
            Appka Promila
          </a>
          <a href="mailto:kontakt@radiopromil.online?Subject=[WWW Radio Promil] Wiadomość od słuchacza" type="link">
            Email Promil
          </a>
        </section>
        <section>
          {/* Polityka Prywatności Button */}
          <button
            className="footer-button"
            onClick={(e) => {
              e.preventDefault();
              openPrivacyPolicy();
            }}
          >
            Polityka Prywatności
          </button>
        </section>  
        <section>
          {/* Zamów Utwór Button */}
          <a
            href="#"
            type="link"
            onClick={(e) => {
              e.preventDefault();

              const iframe = document.createElement("iframe");
              iframe.src = "https://admin.radiopromil.online/public/radio_promil/embed-requests";
              iframe.style = "width:100%; height:100%; border:none; border-radius:10px;";

              const popup = document.createElement("div");
              const popupWidth = window.innerWidth < 768 ? '90%' : '600px';
              const popupHeight = window.innerHeight < 768 ? '90%' : '80%';
              popup.className = "popup";
              popup.style = `
              width: ${popupWidth};
              height: ${popupHeight};
              padding: 20px;
            `;

              const closeButton = document.createElement("button");
              closeButton.innerText = "Zamknij";
              closeButton.className = "popup-close";  // Consistent close button style
              closeButton.onclick = () => document.body.removeChild(popup);

              popup.appendChild(closeButton);
              popup.appendChild(iframe);
              document.body.appendChild(popup);
            }}
          >
            Zamów Utwór
          </a>
          {/* OLED Mode Button */}
          <button
            onClick={() => {
              params.get("oled") !== null
                ? setParams({})
                : setParams({ oled: undefined });
            }}
          >
            OLED Mode
          </button>
          <a
            href="#"
            type="link"
            onClick={(e) => {
              e.preventDefault();

              const popup = document.createElement("div");
              popup.className = "popup";

              const textArea = document.createElement("textarea");
              textArea.placeholder = "Wpisz swoje pozdrowienia...";

              const submitButton = document.createElement("button");
              submitButton.innerText = "Wyślij";
              submitButton.onclick = async () => {
                const text = textArea.value.trim();
                if (text.length < 10) {
                  alert("Pozdrowienia muszą zawierać co najmniej 10 znaków.");
                  return;
                }
                try {
                  const response = await fetch("/api/greetings", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ greeting: text }),
                  });

                  if (response.ok) {
                    alert("Twoje pozdrowienia zostały zapisane!");
                    document.body.removeChild(popup);
                  } else {
                    alert("Wystąpił błąd. Spróbuj ponownie później.");
                  }
                } catch (error) {
                  console.error("Error submitting greeting:", error);
                }
              };

              const closeButton = document.createElement("button");
              closeButton.innerText = "Zamknij";
              closeButton.className = "popup-close";
              closeButton.onclick = () => document.body.removeChild(popup);

              popup.appendChild(closeButton);
              popup.appendChild(textArea);
              popup.appendChild(submitButton);
              document.body.appendChild(popup);
            }}
          >
            Pozdrowienia
          </a>

          {/* O mnie Button */}
          <a
            href="https://zadorozny.me"
            type="link"
            target="_blank"
            rel="noreferrer"
            className="footer-button"
          >
            O mnie
          </a>
          <a
            href="https://facebook.com/radiopromil1"
            type="link"
            target="_blank"
            rel="noreferrer"
            className="footer-button"
            style={{ backgroundColor: "#1877F2", color: "#fff" }}
          >
            Facebook
          </a>
        </section>
      </div>
    </footer>
  );
}
